// Внешние ссылки, которые встречаются больше чем в одном месте.
export const POLICY_URL = '/sites/default/files/cookie_policy_2026.pdf';
export const SUBSCRIBE_URL = '/subscription?source=nestlechoco';
